import React from "react";
import { FieldType } from "../../../services/helpers/types";
import { Checkbox } from "@mui/material";
import TextField from "../../atoms/TextField/TextField";

interface BooleanTextFieldProps {
  field: FieldType;
  value?: string;
  onChange?: (value: string) => void;
}

const BooleanTextField = (props: BooleanTextFieldProps) => {
  const { field, value = "", onChange } = props;
  const handleTextFieldChange = (value: string) => {
    if (onChange) {
      onChange(value);
    }
  };
  const handleCheckboxChange = () => {
    if (onChange) {
      if (value === field.defaultValue) {
        onChange("");
      } else {
        onChange(field.defaultValue);
      }
    }
  };
  return (
    <div className="dui-boolean-text-field">
      <div className="dui-boolean-text-field-checkbox-text">
        {field.defaultValue}
      </div>
      <Checkbox
        checked={value === field.defaultValue}
        onChange={handleCheckboxChange}
        className="dui-boolean-text-field-checkbox"
      />
      <TextField
        field={field}
        onChange={handleTextFieldChange}
        value={value === field.defaultValue ? "" : value}
      />
    </div>
  );
};

export default BooleanTextField;
